module.exports = __webpack_public_path__ + "img/a31.ae5f0fb3.svg";